export default __webpack_public_path__ + "static/media/Semicircle.7225af63.svg";